import { Handshake } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Seo } from "@/components/Seo";
import { PartnerInquiryForm } from "@/components/PartnerInquiryForm";

export default function PartnerInquiry() {
  return (
    <div data-testid="partner-inquiry-page">
      <Seo
        title="Become a Partner"
        path="/partners/connect"
        description="Interested in partnering with Slatech Solutions? Tell us about your business, industry, and what you offer. We're actively seeking new partnerships across drilling, manufacturing, fabrication, safety, mining, equipment, and oil & gas."
      />

      {/* HERO */}
      <section className="relative pt-40 pb-16 md:pt-48 md:pb-20 overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1524514587686-e2909d726e9b"
            alt="Industrial gears connecting"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/85" />
        </div>
        <div className="relative max-w-7xl mx-auto px-6 md:px-12">
          <Reveal>
            <p className="text-xs font-bold tracking-[0.3em] uppercase text-blue-500 mb-5">Become a Partner</p>
            <h1 className="font-heading text-5xl sm:text-6xl md:text-7xl font-black uppercase tracking-tight text-white leading-[0.9] max-w-4xl">
              Let's build something together.
            </h1>
            <p className="mt-6 font-heading text-xl uppercase tracking-wide text-zinc-300">
              Actively seeking new partnerships. Tell us about your business.
            </p>
          </Reveal>
        </div>
      </section>

      {/* FORM */}
      <section className="bg-background py-16 md:py-24 bg-grid">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          <Reveal className="lg:col-span-4">
            <span className="inline-flex text-blue-500"><Handshake size={44} strokeWidth={1.5} /></span>
            <h2 className="font-heading text-3xl font-bold uppercase tracking-tight text-white mt-6">
              Partner with Slatech
            </h2>
            <p className="text-zinc-400 mt-4 leading-relaxed">
              We're always looking to connect with manufacturers, suppliers, contractors, and service
              providers. Share a few details about your business and what you offer — we'd love to have
              a conversation.
            </p>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-8">
            <div className="border border-white/10 bg-zinc-950 p-8 md:p-10">
              <h3 className="font-heading text-2xl font-bold uppercase tracking-tight text-white mb-2">
                Partnership Inquiry
              </h3>
              <p className="text-zinc-400 mb-8">Tell us about your business and what we can bring to the table, together.</p>
              <PartnerInquiryForm />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
